import { useEffect } from "react";

/**
 * Llama `onEscape` cuando el usuario presiona la tecla Escape.
 * Útil para cerrar modales y popovers (WCAG 2.1 A — Keyboard Trap).
 */
export function useEscapeKey(onEscape: () => void, enabled: boolean = true): void {
  useEffect(() => {
    if (!enabled) return;
    const handler = (e: KeyboardEvent) => {
      if (e.key === "Escape") {
        e.stopPropagation();
        onEscape();
      }
    };
    document.addEventListener("keydown", handler);
    return () => document.removeEventListener("keydown", handler);
  }, [onEscape, enabled]);
}
